/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TournamentV5, TournamentV5Interface } from "../TournamentV5";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_assetsAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_gladiatorAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trophyAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "notBefore",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "NewTournament",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "gladiatorId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "faction",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "registrationId",
        type: "uint256",
      },
    ],
    name: "RegistrationEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "winner",
        type: "uint256",
      },
    ],
    name: "TournamentComplete",
    type: "event",
  },
  {
    inputs: [],
    name: "CREATOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "_tournaments",
    outputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "notBefore",
        type: "uint256",
      },
      {
        internalType: "int256",
        name: "maxFactionBonus",
        type: "int256",
      },
      {
        internalType: "uint256",
        name: "firstRoll",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lastRoll",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "gameLogic",
        type: "address",
      },
      {
        internalType: "address",
        name: "roller",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "totalRounds",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "uint16",
            name: "faction",
            type: "uint16",
          },
          {
            internalType: "uint256",
            name: "gladiator",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "trophy",
            type: "uint256",
          },
        ],
        internalType: "struct ITournamentV4.Champion",
        name: "champion",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "checkpoint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "factions",
    outputs: [
      {
        internalType: "string[]",
        name: "",
        type: "string[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "firstRoll",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "getChampion",
    outputs: [
      {
        components: [
          {
            internalType: "uint16",
            name: "faction",
            type: "uint16",
          },
          {
            internalType: "uint256",
            name: "gladiator",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "trophy",
            type: "uint256",
          },
        ],
        internalType: "struct ITournamentV4.Champion",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "lastRoll",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "maxFactionBonus",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "maxGladiators",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "address",
        name: "gameLogic_",
        type: "address",
      },
      {
        internalType: "address",
        name: "roller_",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "totalRounds",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "notBefore",
        type: "uint256",
      },
      {
        internalType: "int256",
        name: "maxFactionBonus",
        type: "int256",
      },
      {
        internalType: "string[]",
        name: "factions",
        type: "string[]",
      },
    ],
    name: "newTournament",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nextTournamentId",
    outputs: [
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "notBefore",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint16[]",
        name: "factions",
        type: "uint16[]",
      },
    ],
    name: "registerGladiators",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "registrationId",
        type: "uint256",
      },
    ],
    name: "registration",
    outputs: [
      {
        components: [
          {
            internalType: "uint16",
            name: "faction",
            type: "uint16",
          },
          {
            internalType: "uint256",
            name: "gladiator",
            type: "uint256",
          },
        ],
        internalType: "struct ITournamentV4.Registration",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "registrationCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "registrations",
    outputs: [
      {
        components: [
          {
            internalType: "uint16",
            name: "faction",
            type: "uint16",
          },
          {
            internalType: "uint256",
            name: "gladiator",
            type: "uint256",
          },
        ],
        internalType: "struct ITournamentV4.Registration[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "roller",
    outputs: [
      {
        internalType: "contract IDiceRolls",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "rollerV5",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "start",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "started",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "totalRounds",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "trophies",
    outputs: [
      {
        internalType: "contract TrophyV5",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class TournamentV5__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _assetsAddress: string,
    _gladiatorAddress: string,
    _trophyAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TournamentV5> {
    return super.deploy(
      _assetsAddress,
      _gladiatorAddress,
      _trophyAddress,
      overrides || {}
    ) as Promise<TournamentV5>;
  }
  getDeployTransaction(
    _assetsAddress: string,
    _gladiatorAddress: string,
    _trophyAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _assetsAddress,
      _gladiatorAddress,
      _trophyAddress,
      overrides || {}
    );
  }
  attach(address: string): TournamentV5 {
    return super.attach(address) as TournamentV5;
  }
  connect(signer: Signer): TournamentV5__factory {
    return super.connect(signer) as TournamentV5__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TournamentV5Interface {
    return new utils.Interface(_abi) as TournamentV5Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TournamentV5 {
    return new Contract(address, _abi, signerOrProvider) as TournamentV5;
  }
}
